import _Upload from './Upload';
import './style';

export type { UploadProps } from './Upload';
export * from './type';
export * from './types';

export const Upload = _Upload;
export default Upload;
